import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FilterPanel from './FilterPanel';

const MobileFilterDrawer = ({
  isOpen,
  onClose,
  selectedSubjects,
  onSubjectToggle,
  selectedLocations,
  onLocationToggle,
  selectedStatuses,
  onStatusToggle,
  dateRange,
  onDateRangeChange,
  onClearFilters,
  facetCounts,
}) => {
  const { t } = useTranslation('conferences');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[1200] lg:hidden"
        onClick={onClose}
      />
      {/* `right-0` pinned the drawer to the physical right, so in Arabic it slid
          in from the wrong edge. `end-0` follows the writing direction. */}
      <div className="fixed inset-y-0 end-0 w-full max-w-sm bg-background z-[1300] lg:hidden overflow-y-auto scrollbar-thin">
        <div className="sticky top-0 bg-background border-b border-border p-4 flex items-center justify-between z-10">
          <h2 className="text-lg font-semibold text-foreground">{t('publicBoard.filters')}</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-250"
            aria-label="Close filters"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-4">
          <FilterPanel
            selectedSubjects={selectedSubjects}
            onSubjectToggle={onSubjectToggle}
            selectedLocations={selectedLocations}
            onLocationToggle={onLocationToggle}
            selectedStatuses={selectedStatuses}
            onStatusToggle={onStatusToggle}
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            onClearFilters={onClearFilters}
            facetCounts={facetCounts}
          />
        </div>

        <div className="sticky bottom-0 bg-background border-t border-border p-4">
          <Button variant="default" size="default" fullWidth onClick={onClose}>
            {t('publicBoard.showResults', 'Show results')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default MobileFilterDrawer;